export default __webpack_public_path__ + "static/media/icon__2.85c0c4a5.svg";